module.exports = __webpack_public_path__ + "static/media/WTAM.01e73d78.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/books/WTAM.jpg
// module id = 1389
// module chunks = 1